export const workOrderByStateReduced = /* GraphQL */ `
  query WorkOrderByState(
    $reloadYardId: ID
    $state: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    workOrderByState(
      reloadYardId: $reloadYardId
      state: $state
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        state
        workType
        poNumber
        createDateTime
        startDateTime
        endDateTime
        assignedTo
        verificationRequired
        accountName
        accountId
        billToAccountId
        reloadYardId
        areaId
        zoneId
        account {
          id
          displayName
          businessName
          accountType
        }
        inputInventory {
          id
          lotNumber
          productName
          inboundShipmentId
          inboundShipment {
            unloadedBy
            sit
            carrierType
            placedDateTime
          }
        }
      }
      nextToken
    }
  }
`;

export const getWorkOrderMobile = /* GraphQL */ `
  query GetWorkOrder($id: ID!) {
    getWorkOrder(id: $id) {
      id
      owner
      groups
      active
      status
      state
      workType
      poNumber
      normalizedPoNumber
      totalUOM
      skipInvoice
      createDateTime
      startDateTime
      endDateTime
      assignedTo
      workflowType
      processedBy
      verificationRequired
      hasException
      brokenSeal
      brokenSealNote
      otherException
      otherExceptionNote
      instructions
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
        public
      }
      accountName
      accountId
      billToAccountId
      reloadYardId
      inputInventoryId
      areaId
      zoneId
      reloadYardCommodityId
      customFields
      selectedCustomFields {
        id
        name
        type
        display
      }
      stepName
      account {
        id
        lotNumberPrefix
        businessName
        displayName
        accountType
        podEmail
        podPhotos
        podAttachments
        inboundCustomFields {
          id
          name
          type
          display
        }
        inboundInstructions
        requireDefaultZone
        inventoryPrimaryField
        inventoryCustomFields {
          id
          name
          type
          display
        }
        trackInboundSeals
        verifyInboundRailCar
        verifyOutboundRailCar
      }
      area {
        id
        name
        color
        prefix
        areaType
      }
      zone {
        id
        name
        prefix
        color
        accountId
        areaId
      }
      inputInventory {
        id
        status
        accountId
        accountName
        productName
        productCode
        productId
        lotNumber
        poNumber
        areaId
        zoneId
        railCarNumber
        receivedAt
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        quantityAdvised
        quantityPrecount
        inventoryUOM
        history {
          type
          date
          by
          text
        }
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        sortKey
        turnDays
        reloadYardCommodityId
        aggregateInventoryId
        customFields
        workOrderId
        inboundShipmentId
        inventoryItems {
          items {
            id
            status
            quantityOnHand
            isDamaged
            locationFullName
            areaId
            zoneId
            aisleId
            locationId
            outboundShipmentId
            location {
              id
              active
              owner
              groups
              reloadYardId
              name
              type
              areaId
              zoneId
              aisleId
              bay
              level
              position
              productId
              productName
              accountName
              sortKey
              capacityUsed
              capacityAllocated
              bulkCapacity
              bulkUnits
              locationLoad {
                other {
                  selected
                  capacity
                }
                pallet {
                  selected
                  capacity
                }
                box {
                  selected
                  capacity
                }
                container {
                  selected
                  capacity
                }
                superSack {
                  selected
                  capacity
                }
                dryBulk {
                  selected
                  capacity
                }
                liquidBulk {
                  selected
                  capacity
                }
              }
            }
          }
        }
        inboundShipment {
          id
          status
          state
          poNumber
          lotNumber
          lotNumberOverride
          carrierType
          railCarNumber
          verificationRequired
          stepName
          unloadedBy
          reviewedBy
          secondaryReview
          sit
          stockImport
          placedDateTime
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          sealNumbers
          containerNumber
          containerDrop
          checklist {
            id
            name
            description
            stepName
            isRequired
            isCompleted
            completedBy
            completedAt
          }
          trackCar {
            id
            active
            areaId
            zoneId
            aisleId
            trackId
            locationFullName
            sortKey
            location {
              id
              name
              type
              areaId
              area {
                id
                name
                prefix
                areaType
              }
              zoneId
              zone {
                id
                name
                prefix
                accountId
                zoneType
              }
              aisleId
              aisle {
                id
                name
                type
              }
            }
          }
          seals {
            items {
              id
              active
              reloadYardId
              accountId
              accountName
              referenceId
              referenceName
              barcode
              createdAt
              createdBy
              brokenAt
              brokenBy
              validated
              owner
              isScanned
              description
              updatedAt
            }
          }
        }
      }
      outputInventories {
        items {
          id
          status
          accountId
          accountName
          productName
          productCode
          productId
          lotNumber
          poNumber
          areaId
          zoneId
          railCarNumber
          receivedAt
          verificationRequired
          hasException
          quantityAdvised
          quantityPrecount
          inventoryUOM
          sortKey
          turnDays
          customFields
          workOrderId
          inboundShipmentId
          inventoryItems {
            items {
              id
              status
              quantityOnHand
              isDamaged
              locationFullName
              areaId
              zoneId
              aisleId
              locationId
              outboundShipmentId
            }
          }
        }
      }
    }
  }
`;
